// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"tooltip-provider_uk-open__INdHe","grecaptcha-badge":"tooltip-provider_grecaptcha-badge__vW3p9","tooltip":"tooltip-provider_tooltip__RbKQd"};
    if(module.hot) {
      // 1793877023062
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  